import * as React from 'react'
import clsx from 'clsx'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import style from '../../style'

export interface GridColumnHeaderTitleProps {
  label: string | React.ReactNode
  columnWidth: number
}

export const GridColumnHeaderTitle = React.memo(
  (props: GridColumnHeaderTitleProps) => {
    const rootProps = useGridRootProps()
    const { label } = props
    return (
      <div
        className={clsx(
          style.columnHeaderTitle,
          rootProps.classes?.columnHeaderTitle
        )}
      >
        {label}
      </div>
    )
  }
)

GridColumnHeaderTitle.displayName = 'GridColumnHeaderTitle'
